import { Listbox, ListboxOption } from '@/components/base/listbox'
import { Color } from '@/types'

interface Props {
  value: Color
  onChange: (value: Color) => void
}

const colors: Record<Color, { bg: string, border: string }> = {
  red: { bg: 'bg-red-500', border: 'border-red-400' },
  orange: { bg: 'bg-orange-500', border: 'border-orange-400' },
  yellow: { bg: 'bg-yellow-500', border: 'border-yellow-400' },
  lime: { bg: 'bg-lime-500', border: 'border-lime-400' },
  green: { bg: 'bg-green-500', border: 'border-green-400' },
  emerald: { bg: 'bg-emerald-500', border: 'border-emerald-400' },
  teal: { bg: 'bg-teal-500', border: 'border-teal-400' },
  sky: { bg: 'bg-sky-500', border: 'border-sky-400' },
  blue: { bg: 'bg-blue-500', border: 'border-blue-400' },
  indigo: { bg: 'bg-indigo-500', border: 'border-indigo-400' },
  purple: { bg: 'bg-purple-500', border: 'border-purple-400' },
  pink: { bg: 'bg-pink-500', border: 'border-pink-400' },
  gray: { bg: 'bg-gray-500', border: 'border-gray-400' },
  black: { bg: 'bg-black', border: 'border-gray-500' },
}

export const Selector = ({ value, onChange }: Props) => {
  return (
    <Listbox value={value} onChange={onChange}>
      { Object.keys(colors).map(option => (
        <ListboxOption key={option} value={option}>
          <span className={`w-6 h-6 rounded-full ${colors[option as Color].bg} ${colors[option as Color].border}`} />
        </ListboxOption>
      )) }
    </Listbox>
  )
}
